module.exports = __webpack_public_path__ + "assets/svg/Icons/32/shift-leave-blue-85f7cf.svg";